/**
 * Ground truth: TenantMigrationSummaryDto / TenantMigrationResultDto
 * (ASP.NET camelCase JSON from POST /businessOrganisation/migrate/*).
 */

export function tenantMigrationAllCounts(summary) {
  return {
    successCount: summary?.succeeded ?? 0,
    failedCount: summary?.failed ?? 0,
  };
}

export function tenantMigrationSingleOutcome(summary) {
  const result = summary?.results?.[0];
  if (result?.success) {
    return { ok: true, error: null };
  }
  return { ok: false, error: result?.error || 'Unknown error' };
}
